import clsx from 'clsx';
import {
  PlannerBundle,
  PlannerOrder,
} from 'pages/planner/utils/usePlannerData';
import React, { useEffect, useState } from 'react';

interface PlannerFilterStoreProps {
  orders: PlannerOrder[][];
  bundles: PlannerBundle[];
  selectedStores: string[];
  onChange: (stores: string[]) => void;
}

export const PlannerFilterStore = ({ ...props }: PlannerFilterStoreProps) => {
  const [storeDataMap, setStoreDataMap] = useState<Map<string, number>>();

  /* Map all Store data */
  useEffect(() => {
    const storeData = new Map();

    const addNewStore = (store: string) => {
      storeData.set(store, 0);
    };

    const arrangeOrderCount = (plannerOrders: PlannerOrder[][]) => {
      plannerOrders.map(groupedOrders => {
        groupedOrders.map(order => {
          if (!storeData.has(order.senderName)) {
            addNewStore(order.senderName);
          }

          /* Increase the order count */
          let newData = storeData.get(order.senderName);
          newData++;
          storeData.set(order.senderName, newData);

          return order;
        });

        return groupedOrders;
      });
    };

    arrangeOrderCount(props.orders);

    props.bundles.map(bundle => {
      arrangeOrderCount(bundle.orders);

      return bundle;
    });

    setStoreDataMap(storeData);
  }, [props.bundles, props.orders]);

  const onStoreChange = (store: string) => {
    const newSelectedStores = [...props.selectedStores];

    const indexOfChosenStore = newSelectedStores.indexOf(store);
    const chosenStoreHasBeenSelected = indexOfChosenStore >= 0;

    if (chosenStoreHasBeenSelected) {
      /* Remove the Store from SelectedStore */
      newSelectedStores.splice(indexOfChosenStore, 1);
    } else {
      /* Add the Store to SelectedStore */
      newSelectedStores.push(store);
    }

    props.onChange(newSelectedStores);
  };

  if (storeDataMap) {
    const sortedStoreByCount = [...storeDataMap].sort(
      ([_storeNameA, orderCountA], [_storeNameB, orderCountB]) => {
        return orderCountB - orderCountA;
      }
    );

    return (
      <div className="stores">
        {sortedStoreByCount.map(([storeName, orderCount], index) => (
          <button
            key={`store-filter-${index}`}
            onClick={() => onStoreChange(storeName)}
            className={clsx({
              active: props.selectedStores.includes(storeName),
            })}
          >
            <strong>{storeName}</strong>
            <strong>{orderCount}</strong>
          </button>
        ))}
      </div>
    );
  }

  return <></>;
};
